import { useEffect } from 'react';
import { setTitle } from '@/lib/seo';

export function useRouteTitle(title?: string) {
  useEffect(() => { setTitle(title); }, [title]);
}
